const ItemEditableStatus = require('@/lib/Orders/ItemEditableStatus');
const ItemType = require('@/lib/Items/ItemType');

/**
 * @param {OrderLine[]} orderLines
 * @return {{membership: Membership, membershipPlan: MembershipPlan, membershipSubscription: MembershipSubscription}[]}
 */
const getMembershipsFromOrderLines = (orderLines) => {
    const memberships = [];

    orderLines.forEach((orderLine) => {
        orderLine.iteminstances.forEach((itemInstance) => {
            if (itemInstance.membership) {
                memberships.push({
                    membership: itemInstance.membership,
                    membershipPlan: orderLine.item,
                    membershipSubscription: itemInstance.membershipSubscription,
                });
            }
        });
    });

    return memberships;
};

/**
 * @param {OrderLine} line
 * @param {AbstractItem} item Item can be passed in because when mapping to a Cart we use the Item from
 *                            IndexedDB, which usually has more info than the item from the order line.
 *
 * @returns {string}
 */
const getOrderLineEditableStatus = (line, item) => {
    if (line.isExpired()) {
        return ItemEditableStatus.IS_EXPIRED;
    }

    if (line.itemType !== ItemType.TICKET
        && line.itemType !== ItemType.PRODUCT
        && line.itemType !== ItemType.PRODUCT_FOOD
    ) {
        // Only tickets or products can be edited currently.
        return ItemEditableStatus.IS_NOT_EDITABLE_TYPE;
    }

    if (line.itemType === ItemType.TICKET && (!line.isRedemptionAllowed() || line.redeemed >= line.qty)) {
        // Already fully redeemed.
        return ItemEditableStatus.IS_REDEEMED;
    }

    if ((item || line.item)?.hasBookableResources) {
        return ItemEditableStatus.HAS_BOOKABLE_RESOURCES;
    }

    return ItemEditableStatus.IS_EDITABLE;
};

/**
 * @param {OrderLine} line
 * @param {AbstractItem} item
 *
 * @returns {string}
 */
const isOrderLineEditable = (line, item) => {
    return getOrderLineEditableStatus(line, item) === ItemEditableStatus.IS_EDITABLE;
};

/**
 * Sort order lines.
 * The sorting rules are:
 * - Keep the original order.
 * - But where lines have a parentID, move them to be after their parent line
 *   (but also maintaining the order of the children).
 *
 * @param {OrderLine[]} items
 */
const sortOrderLines = (items) => {
    const result = [];
    const childItems = new Map();

    // First pass: collect all child items
    for (const item of items) {
        if (item.parentID) {
            if (!childItems.has(item.parentID)) {
                childItems.set(item.parentID, []);
            }
            childItems.get(item.parentID).push(item);
        }
    }

    // Second pass: add parent items and their children
    for (const item of items) {
        if (!item.parentID) {
            result.push(item);
            if (childItems.has(item.ID)) {
                result.push(...childItems.get(item.ID));
            }
        }
    }

    // If any child lines remained that didn't have a parent line, add them at the end.
    // for (const [parentID, children] of childItems.entries()) {
    //     if (!items.find((item) => item.ID === parentID)) {
    //         result.push(...children);
    //     }
    // }

    // Replace the contents of the original array in-place like other sort functions.
    items.splice(0, items.length, ...result);
};

module.exports = {
    getMembershipsFromOrderLines,
    getOrderLineEditableStatus,
    isOrderLineEditable,
    sortOrderLines,
};
